import { Paragraph, Text, Title } from "@smartsuite/react-ui/lib";
import type { EditorData } from "@smartsuite/types";
import type React from "react";
import { FormattedMessage } from "react-intl";
import {
  getEffectiveSubmissionConfig,
  isSubmissionDescriptionEmpty,
} from "../../helpers/submissionPage";
import type { FormConfig, SubmissionPageConfig } from "../../types/form";
import { SmartDocRenderer } from "../common/SmartDocRenderer/SmartDocRenderer";

import "./FormSubmittedMessage.sass";

export interface FormSubmittedMessageProps {
  config: FormConfig;
  onSubmitAnother: () => void;
}

const renderDescription = (
  description: SubmissionPageConfig["description"],
): JSX.Element | null => {
  if (isSubmissionDescriptionEmpty(description)) return null;

  if (typeof description === "string") {
    const multilineDescription = description.split("\n");
    return (
      <Paragraph size="l" weight="regular" className="form-submitted-message__subtitle">
        <Text size="l">
          {multilineDescription.map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
        </Text>
      </Paragraph>
    );
  }

  return (
    <SmartDocRenderer
      className="form-submitted-message__subtitle form-submitted-message__rich-description"
      editorData={description as EditorData}
    />
  );
};

export const FormSubmittedMessage: React.FC<FormSubmittedMessageProps> = ({
  config,
  onSubmitAnother,
}) => {
  const submission = getEffectiveSubmissionConfig(config.form_state);

  return (
    <div className="form-submitted-message">
      {submission.display_icon && (
        <Paragraph className="form-submitted-message__img-container">
          <img src="/form/images/form-sent.svg" alt="Form Sent" data-testid="form-submitted-icon" />
        </Paragraph>
      )}

      <Title size="xxl" weight="bold">
        {submission.title}
      </Title>

      {renderDescription(submission.description)}

      <Paragraph
        size="l"
        weight="regular"
        className="form-submitted-message__retry-button"
        color={"tertiary"}
      >
        <FormattedMessage
          defaultMessage={`Want to submit another response ? <link>Click here</link>.`}
          id="1x4g3N"
          values={{
            link: (content) => {
              return (
                <Text
                  color="link"
                  className="form-submitted-message__submit-another"
                  size="l"
                  weight="regular"
                  onClick={onSubmitAnother}
                >
                  {content}
                </Text>
              );
            },
          }}
        />
      </Paragraph>
    </div>
  );
};
